import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { EventsService } from "../event/event.service";

@Injectable({
  providedIn: "root",
})
export class MobileDataService {
  public insets: any;
  public allGamesArray: any;
  public keyWordList: any;
  public mobileBottomKeyWordList: any[] = null;
  public mobileTopKeywordList: any[] = null;
  public mobileCasinoKeywordDeepLinkData: any[] = null;
  public defaultKeyword = {
    topKeyword: null,
    bottomKeyword: {"name": "Home"},
  };
  _mobileLobbyKeyword: BehaviorSubject<any> = new BehaviorSubject(
    this.defaultKeyword
  );
  private _mobileCasinoDeeplink: BehaviorSubject<any> = new BehaviorSubject(null);
  private activeMobileKeyword: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public hiddenKeywordList:any;
  private currentLobbyKeyword: any = null;
  private mobileLobbyKeywordSubject = new BehaviorSubject<any>(null);

  constructor(private eventsService: EventsService) {
      this.eventsService.subscribe('event:mobile-tabs-updated', (bottomKeywords)=>this.setLobbiesList(bottomKeywords));
  }

  setLobbiesList(casinoLobbies) {
    if (casinoLobbies) {
      let mainLobbies = casinoLobbies.filter((l) => l.placement === "MAIN");
      let bottomLobbies = casinoLobbies.filter((l) => l.placement === "BOTTOM");

      if (bottomLobbies.length > 0){
        this.setBottomKeywordList(bottomLobbies[0].keywordInfo);
        console.log("bottomLobbies", bottomLobbies[0].keywordInfo);
      }
      
      if (mainLobbies.length > 0){
        //Seprate out list for Hidden and non-Hidden Casino category for Mobile Apps
        let mainLobbiesWithoutHidden = mainLobbies[0].keywordInfo.filter((k) => k.hide_keyword === false);
        let mainLobbiesWithHidden = mainLobbies[0].keywordInfo.filter((k) => k.hide_keyword === true);
        this.setHiddenKeywordListMobile(mainLobbiesWithHidden);
        this.setTopKeywordList(mainLobbiesWithoutHidden);
      }
       
    }
  }

  getBottomKeywordList() {
    return this.mobileBottomKeyWordList;
  }

  getTopKeywordList() {
    return this.mobileTopKeywordList;
  }

  setBottomKeywordList(keyWordList) {
    this.mobileBottomKeyWordList = keyWordList;
  }

  setTopKeywordList(keyWordList) {
    this.mobileTopKeywordList = keyWordList;
  }

  public getCurrentLobbyKeyword(): any {
    return this.currentLobbyKeyword;
  }

  public setMobileLobbyKeyword(keyword: any): void {
    this.currentLobbyKeyword = keyword;
    this.mobileLobbyKeywordSubject.next(keyword);
  }

  public getMobileLobbyKeyword(): Observable<any> {
    return this.mobileLobbyKeywordSubject.asObservable();
  }

  setMobileCasinoDeeplink(deeplinkValue) {
    this._mobileCasinoDeeplink.next(deeplinkValue);
  }
  getMobileCasinoDeeplink() {
    return this._mobileCasinoDeeplink;
  }

  sendExternalSelection(selection) {
    this.setMobileLobbyKeyword({
      topKeyword: null,
      bottomKeyword: selection,
    });
  }

  getActiveMobileKeyword(): Observable<any> {
    return this.activeMobileKeyword.asObservable();
  }

  setActiveMobileKeyword(keyword: any): void {
    this.activeMobileKeyword.next(keyword);
  }

  setMobileAppCasinoKeywordDeepLink(data){
    this.mobileCasinoKeywordDeepLinkData = data;
  }

  getMobileAppCasinoKeywordDeepLink(){
    return this.mobileCasinoKeywordDeepLinkData;
  }

  public setHiddenKeywordListMobile(list:any){
    this.hiddenKeywordList = list;
  }

  public getHiddenKeywordListMobile(){
    return this.hiddenKeywordList;
  }

}
